import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent, ProgressBarService, SignaturePadComponent } from '@mrm/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'emreg-signature-pad-modal',
  templateUrl: './signature-pad-modal.component.html',
  styleUrls: ['./signature-pad-modal.component.scss']
})
export class SignaturePadModalComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() title: string = this._translateService.instant('SignaturePad');
  @Input() name: string = null;
  @ViewChild(SignaturePadComponent, { static: true }) signaturePad: SignaturePadComponent;

  signatureForm: FormGroup;
  data: any;

  constructor(
    private __progressBarService: ProgressBarService,
    private __toastr: ToastrService,
    private __translateService: TranslateService,
    public activeModal: NgbActiveModal,
    private _formBuilder: FormBuilder
  ) {
    super(__progressBarService, __toastr, __translateService);
  }

  get signatureCompleted(): boolean {
    try {
      return this.signaturePad.isEmpty();
    } catch {
      return false;
    }
  }

  signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'canvasWidth': 750,
    'canvasHeight': 300
  };

  ngAfterViewInit() {
    this.signaturePad.set('minWidth', 2); // set szimek/signature_pad options at runtime
    this.signaturePad.set('penColor', 'rgb(66,66,66)');
    this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
  }

  ngOnInit(): void {
    // Set up form.
    this.signatureForm = this._formBuilder.group({
      name: [this.name, Validators.required]
    });
  }

  drawComplete() {
    // get byte array
    this.data = this.signaturePad.toDataURL().split(',')[1];
  }

  drawStart() {
  }

  ok(): void {
    if (this.signatureForm.valid) {
      if (this.data && this.data != null) {
        this.activeModal.close({ name: this.signatureForm.value.name, data: this.data });
      } else {
        this._toastr.error(this._translateService.instant('SignatureRequired'));
      }
    } else { this._toastr.error(this._translateService.instant('FillRequiredFields')); }
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  clear(): void {
    this.signaturePad.clear();
  }

  ngOnDestroy(): void {
  }
}